import Cookies from 'js-cookie'

const TokenKey = 'yuanlai-token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenKey, token)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
